import React, { memo } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

const RequestIcon = ({ className }) => (
  <SvgIcon viewBox="0 0 24 24" className={className}>
    <circle cx="12" cy="12" r="12" fill="#DC0032" />
    <path
      d="M12.6025 13.3564H10.9687V17H8.91797V7.04688H12.6162C13.792 7.04688 14.6989 7.30892 15.3369 7.83301C15.9749 8.3571 16.2939 9.09766 16.2939 10.0547C16.2939 10.7337 16.1458 11.3011 15.8496 11.7568C15.5579 12.208 15.1136 12.568 14.5166 12.8369L16.6699 16.9043V17H14.4687L12.6025 13.3564ZM10.9687 11.6953H12.623C13.138 11.6953 13.5368 11.5654 13.8193 11.3057C14.1019 11.0413 14.2432 10.679 14.2432 10.2188C14.2432 9.74935 14.1087 9.38021 13.8398 9.11133C13.5755 8.84245 13.1676 8.70801 12.6162 8.70801H10.9687V11.6953Z"
      fill="white"
    />
  </SvgIcon>
);

export default memo(RequestIcon);
